/*
 * Author: Ben Zhao
 * File Created: Friday, 25-01-17 12:01 pm
 * Last Modified: Tuesday, 25-02-18 09:34 pm, by Harper Yan
 */

import { Box, styled, typographyClasses } from '@mui/material';

export const IconBox = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'targetTextWidth',
})<{ targetTextWidth: number }>(({ targetTextWidth }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '50px',
  borderRadius: '25px',
  border: '1px solid rgba(132, 142, 156, 0.3)',
  background: '#1A1A1A',
  padding: '0 10px',
  cursor: 'pointer',
  [`& .${typographyClasses.root}`]: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#FFF',
    whiteSpace: 'nowrap',
    width: '0',
    overflow: 'hidden',
  },
  [`&:hover`]: {
    width: 'auto',
    transition: 'width 0.5s ease',
    [`& .${typographyClasses.root}`]: {
      width: `${targetTextWidth}px`,
      marginLeft: '8px',
      transition: 'width 0.3s ease',
    },
  },
}));
